<!-- 护理人员配置 -->
<template>
  <div class="main" style="width: 1180px;">
    <a-card>
      <div>
        关于"{{keyWord}}"共搜索到
        <span class="color63B5FF">{{allData.total}}</span>
        条结果
        <router-link class="color63B5FF ml20 cursorPointer" to="./radarBed" tag="span">返回</router-link>
      </div>
      <div class="reListWrap p30" v-if="allData && allData.total > 0">
        <div class="reList" :key="index" v-for="(item,index) in allData.records">
          {{item.snCode}} - 
          <span class="color63B5FF cursorPointer" @click="goBuild(item)">{{item.buildingName}}</span> 
          - <span class="color63B5FF cursorPointer" @click="goFloor(item)">{{item.floorName}}</span> 
          - {{item.roomName}} - {{item.bedName}}
        </div>
      </div>
      <!-- 分页 -->
      <a-pagination :pageSize="pageSize" v-model="pageNum" :total="allData.total" @change="pageChange" show-less-items style="text-align: center; margin-top: 20px" :hideOnSinglePage="true" />
      <div class="p30" v-if="allData && allData.total == 0">
        <a-empty description="暂无内容哦"/>
      </div>
    </a-card>
  </div>
</template>

<script>

export default {
  components: {
    
  },
  data() {
    return {
      keyWord: this.$route.query.keyWord,
      pageNum: 1,
      pageSize: 20,
      allData: '',
    };
  },
  created() {},
  mounted() {
    this.getBuildingSearchPage()
  },
  methods: {
    // 获取搜索分页数据
    getBuildingSearchPage(){
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        snCode: this.keyWord,
      };
      this.$get(
        "/api/v3/building/getBuildingSearchPage",
        param,
        (res) => {
          if (res.code == 0) {
            this.allData = res.data.buildingV3SearchVoPage;
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    // 分页
    pageChange(e) {
      console.log(e);
      this.pageNum = e;
      this.getBuildingSearchPage();
    },
    // 进楼
    goBuild(item){
      this.$router.push({
        path: "./goBuild?buildId=" + item.buildingId + '&buildName=' + item.buildingName,
      });
    },
    // 进层
    goFloor(item){
      this.$router.push({
        path: "./goFloor?buildId=" + item.buildingId + '&buildName=' + item.buildingName + '&floorId=' + item.floorId + '&floorName=' + item.floorName,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main::v-deep {
  padding: 20px 0;
  .ant-card {
    padding: 15px 20px;
    border-radius: 8px;
    .ant-card-body {
      padding: 0;
    }
  }
  .ant-tabs-bar {
    border-bottom: none;
  }
  .reList {
    margin-top: 10px;
  }
  .reList:nth-of-type(1) {
    margin-top: 0;
  }
}
</style>